import { GreenroomState } from '../types/types';

export const selectBlpSession = (state: GreenroomState) => state.SessionReducer.blpSession;

export const selectOpentokSession = (state: GreenroomState) => (state.OpenTokReducer.opentokSession
	? state.OpenTokReducer.opentokSession
	: state.SessionReducer.meeting?.opentok_session ?? null);

export const selectPlatformRedirectUrl = (state: GreenroomState): string | null => {
	if (process.env.REACT_APP_NODE_ENV === 'local') return null;
	return state.SessionReducer.meeting?.platform_redirect_url || null;
};

export const selectRecordingEnabled = (state: GreenroomState): boolean => (
	state.SessionReducer.meeting?.streaming_options?.do_not_record !== true
);
